module.exports = __webpack_public_path__ + "static/media/AI_8.7b9e01da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_8.png
// module id = 123
// module chunks = 0